/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'box': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<defs/><path pid="0" id="box" class="cls-1" d="M44.406 325.083l-9-4a.992.992 0 0 0-.812 0l-9 4A1 1 0 0 0 25 326v10a1 1 0 0 0 .594.914l9 4a1 1 0 0 0 .813 0l9-4A1 1 0 0 0 45 336v-10a1 1 0 0 0-.594-.917zM35 323.09l6.538 2.91-1.788.8-6.538-2.906zm0 5.813L28.462 326l2.288-1.017 6.538 2.907zm-8-1.367l7 3.112v7.813l-7-3.112v-7.813zm9 10.925v-7.813l7-3.112v7.813z" transform="translate(-25 -321)"/>'
  }
})
